import { render } from "./market-web.vue?vue&type=template&id=3993b248"
import script from "./market-web.vue?vue&type=script&lang=js"
export * from "./market-web.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__